import { environment } from './../../../environments/environment';
import { Dashboard } from './../../shared/interceptors/token.interceptor';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  public headers: HttpHeaders = new HttpHeaders({}).set(Dashboard, 'Dashboard');

  constructor(private _http: HttpClient) { }

  /**
   * Trae la información del usuario
   */
  getUserProfileInformation() {
    return this._http.get(environment.profile.USER_PROFILE, {
      headers: this.headers,
    });
  }

  /**
   * Cambio de contraseña dentro del app
   * @param form Formulario de cambio de contraseña
   */
  userChangePassword(form) {
    return this._http.post(environment.profile.USER_CHANGE_PASSWORD, form, {
      headers: this.headers,
    });
  }

  /**
   * Establecer estado de descanso del usuario
   * @param form Formulario con status ('REST' o 'NOT_REST'), observation y opcionalmente concept_id y concept
   */
  setUserRest(form: { status: string; observation: string; concept_id?: number; concept?: string }) {
    return this._http.post(environment.profile.SET_USER_REST, form, {
      headers: this.headers,
    });
  }

  /**
   * Obtener lista de conceptos filtrados por tipo
   * @param type Tipo de concepto: 'CANCEL', 'REST', 'PENDING', 'REVERSE'
   */
  getConceptsList(type: string) {
    return this._http.get(`${environment.profile.CONCEPTS_LIST}?type=${type}`, {
      headers: this.headers,
    });
  }
}
